<form [formGroup]="form" autocomplete="off">
  <div class="text-center italic mb-36px mt-36px md:mt-16px">
    <ng-container *ngIf="!formS.isCompanyAccount">{{
      config.description | transloco
    }}</ng-container>

    <ng-container *ngIf="formS.isCompanyAccount">{{
      config.descriptionCompany | transloco
    }}</ng-container>
  </div>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.EMAIL"
    [formCtrl]="form.get(SIGN_UP_FIELDS.EMAIL)"
    [showClearBtn]="true"
    [showLoader]="checkEmailLoading$ | async"
  >
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input
        #emailInput
        matInput
        formControlName="{{ SIGN_UP_FIELDS.EMAIL }}"
        autocomplete="new-password"
        required
        (keydown.enter)="submitFromInput($event)"
        autocomplete="email"
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.PASSWORD"
    [formCtrl]="form.get(SIGN_UP_FIELDS.PASSWORD)"
    [htmlInputEl]="passw"
    [showPasswVisibilityBtn]="true"
    [tooltipText]="
      'Length of password from 8 to 100 characters. Must contain: At least one uppercase symbols, At least one lowercase symbols, At least one number, At least one specific symbol: ' +
      PASSWORD_SPECIFIC_SYMBOLS
    "
  >
    <mat-form-field>
      <mat-label>Password</mat-label>
      <input
        matInput
        #passw
        type="password"
        (keydown.enter)="submitFromInput($event)"
        autocomplete="new-password"
        formControlName="{{ SIGN_UP_FIELDS.PASSWORD }}"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.PASSWORD_REPEAT"
    [formCtrl]="form.get(SIGN_UP_FIELDS.PASSWORD_REPEAT)"
    [htmlInputEl]="passwRepeat"
    [hideErrors]="picker.opened"
    [showPasswVisibilityBtn]="true"
  >
    <mat-form-field>
      <mat-label>Re-enter Password</mat-label>
      <input
        matInput
        #passwRepeat
        type="password"
        (keydown.enter)="submitFromInput($event)"
        autocomplete="new-password"
        formControlName="{{ SIGN_UP_FIELDS.PASSWORD_REPEAT }}"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.FIRST_NAME"
    [formCtrl]="form.get(SIGN_UP_FIELDS.FIRST_NAME)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input
        matInput
        formControlName="{{ SIGN_UP_FIELDS.FIRST_NAME }}"
        required
        (keydown.enter)="submitFromInput($event)"
        autocomplete="off"
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.LAST_NAME"
    [formCtrl]="form.get(SIGN_UP_FIELDS.LAST_NAME)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input
        matInput
        formControlName="{{ SIGN_UP_FIELDS.LAST_NAME }}"
        required
        (keydown.enter)="submitFromInput($event)"
        autocomplete="off"
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    class="sm:w-1/2"
    [formCtrlName]="SIGN_UP_FIELDS.DOB"
    [formCtrl]="form.get(SIGN_UP_FIELDS.DOB)"
    tooltipText="You must be 18 years of age"
    [hideErrors]="picker.opened"
  >
    <mat-form-field (click)="picker.opened ? picker.close() : picker.open()">
      <mat-label>Date of Birth</mat-label>
      <input
        matInput
        [max]="maxDate"
        [matDatepicker]="picker"
        (focus)="picker.open()"
        [readonly]="true"
        formControlName="{{ SIGN_UP_FIELDS.DOB }}"
        placeholder="{{ dateFormat$ | async }}"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <hr />

  <ng-container *ngIf="reinitPhone; else phoneTmpl">
    <ng-container [ngTemplateOutlet]="phoneTmpl"></ng-container>
  </ng-container>
  <ng-template #phoneTmpl>
    <ib-mat-form-field-wrap
      class="sm:w-3/4"
      [formCtrlName]="SIGN_UP_FIELDS.PHONE"
      [formCtrl]="form.get(SIGN_UP_FIELDS.PHONE)"
      [showLoader]="checkPhoneLoading$ | async"
      [showEditBtn]="formS.isPhoneConfirmed"
      (editClicked)="editPhoneClicked()"
    >
      <ib-phone
        #phoneInput
        [formCtrl]="form.get(SIGN_UP_FIELDS.PHONE)"
        [countryFormCtrl]="form.get(SIGN_UP_FIELDS.PHONE_COUNTRY)"
        [disabled]="phoneDisabled$ | async"
        [autodetectedCountryIso$]="autodetectedCountryIso$"
        (keydownEnterClicked)="submitFromInput($event)"
      >
      </ib-phone>
    </ib-mat-form-field-wrap>
  </ng-template>

  <!-- <ib-tooltip
    *ngIf="
      form.get(SIGN_UP_FIELDS.PHONE).valid && (phoneDisabled$ | async) !== true
    "
    class="block -mt-16px"
    text="Confirmation Code will be sent to {{
      form.get(SIGN_UP_FIELDS.PHONE).value
    }}"
  >
  </ib-tooltip> -->
</form>
